import { createTheme } from "@mui/material";

export const theme = createTheme({
    palette: {
        primary: {
            main: "#6a00ff", // --purple
            contrastText: "#ffffff", // --white
        },
        secondary: {
            main: "#3a008c", // --darkPurple
            contrastText: "#ffffff",
        },
        background: {
            default: "#dee0e2", // --lightGray
            paper: "#ffffff", // --white
        },
        text: {
            primary: "#1a1a1a", // --darkGray (o puedes usar --black)
            black: "000000",
            // Puedes agregar otros niveles de texto si es necesario
        },
    },
    typography: {
        fontFamily: '"SpaceGroteskRegular", sans-serif', // --regular
        h1: {
            fontFamily: '"SpaceGroteskBold", sans-serif', // --bold
        },
        h2: {
            fontFamily: '"SpaceGroteskBold", sans-serif',
        },
        h3: {
            fontFamily: '"SpaceGroteskBold", sans-serif',
        },
        h4: {
            fontFamily: '"SpaceGroteskBold", sans-serif',
        },
        h5: {
            fontFamily: '"SpaceGroteskBold", sans-serif',
        },
        h6: {
            fontFamily: '"SpaceGroteskBold", sans-serif',
        },
        p: {
            fontFamily: '"SpaceGroteskRegular", sans-serif',
        },
    },
});
